import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var w=s=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24","stroke-width":"2"},s),{children:jsx("path",{d:"M21 12a9 9 0 1 1-6.219-8.56"})})),h=w;

export { h as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-2QOW5GVI.mjs.map